<script setup lang="ts">
import NotificationToast from '@/components/common/NotificationToast.vue'
import GlobalLoader from '@/components/common/GlobalLoader.vue'
import RouteProgressBar from '@/components/common/RouteProgressBar.vue'
import { TourRoot } from '@/features/tour'
</script>

<template>
	<router-view />
	<RouteProgressBar />
	<GlobalLoader />
	<NotificationToast />
	<TourRoot />
</template>

<style scoped lang="scss"></style>
